import React from 'react';
import { IconProps } from '@/models/IconProps';

const PlayIcon: React.FC<IconProps> = ({ height = '24', width = '24', strokeColor }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_3768_45870)">
        <path
          d="M23.482 11.1242L3.48201 0.124169C3.32859 0.0388207 3.15541 -0.00463375 2.97987 -0.00182512C2.80433 0.000983509 2.63262 0.0499562 2.48201 0.140169C2.33422 0.229665 2.21214 0.355926 2.12767 0.506644C2.04319 0.657362 1.99921 0.827395 2.00001 1.00017V23.0002C2.00025 23.1739 2.04574 23.3446 2.13202 23.4954C2.21829 23.6462 2.34236 23.7719 2.49201 23.8602C2.64543 23.9522 2.82109 24.0007 3.00001 24.0002C3.16856 24.0001 3.33436 23.9575 3.48201 23.8762L23.482 12.8762C23.6388 12.7898 23.7695 12.663 23.8606 12.5089C23.9517 12.3549 23.9997 12.1792 23.9997 12.0002C23.9997 11.8212 23.9517 11.6455 23.8606 11.4914C23.7695 11.3373 23.6388 11.2105 23.482 11.1242Z"
          fill={strokeColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_3768_45870">
          <rect width={width} height={height} fill="none" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default PlayIcon;
